import AnimateProxyBase from "./animate-proxy-base";
import { isFunction } from "../utils";
import TimingInfo from "../timing-info";

/**
 * @category Animate Proxys
 * @description have a primary class for handling canvas based render spaces, which is most of them.  This class will handle the canvas element and the bounds management
 
*/
export class AnimateButtonProxy extends AnimateProxyBase {
  // Converted to use only seconds units  RLB 8/30/2020
  protected mouseDown: boolean = false;
  protected _onHeld: (timingInfo?: TimingInfo) => void;
  protected _onPressCallback: (e: MouseEvent) => void = null;
  protected pressStart: number; // time when button mousedown in seconds
  protected _holdDelay: number = 0.25; // Seconds

  onFrameZero() {
    // Listen for mousedown and bind the buttonPressed function to this
    this.stageSymbol.addEventListener(
      "mousedown",
      this.buttonPressed.bind(this)
    );
    window.addEventListener("mouseup", () => {
      this.mouseDown = false; // this will be used only for onHeld
    });
  }
  public buttonPressed(e: MouseEvent) {
    if (this._onPressCallback) {
      // A callback function exists; it must have been stored by an external function
      // Run that callback function:
      this._onPressCallback(e);
    }
    // Now get ready to do onHeld actions:
    this.mouseDown = true;
    this.pressStart = this.timingInfo.now;
  }

  public onPress(eventCallback: (e: MouseEvent) => void) {
    // Allows external function to store a callback function for later use.
    // Define _onPressCallback to be whatever the external function wants saved.
    this._onPressCallback = eventCallback;
  }

  public onHeld(eventCallback: (timingInfo?: TimingInfo) => void) {
    this._onHeld = eventCallback;
  }

  public setDelay(delay: number = 0) {
    this._holdDelay = delay;
  }

  public onRequestAnimFrame(timingInfo: TimingInfo) {
    if (
      this.mouseDown && // Mouse is still down
      timingInfo.timeSince(this.pressStart) > this._holdDelay && // We'v exceeded holdDelay elapsed time
      this._onHeld
    ) {
      // An onHeld function has been saved
      this._onHeld(timingInfo); // Then go ahead and run the onHeld function every frame.
    }
  }
}

export default AnimateButtonProxy;
